import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: '0.25rem'
  }
}))

export default useStyles
